import api from "../helpers/axios";

class SasUrlService {
    async generateSasUrl(blobUrl) {
        try {
            const response = await api.post('/blob/generate_sas_url', { blob_url: blobUrl });
            return response?.data;
        } catch (error) {
            console.error('Error generating SAS URL:', error);
            throw error;
        }
    }
}

export default new SasUrlService();